import { Component, Inject, OnInit } from '@angular/core'
import { CaDialogComponent } from '../../../../shared/dialogs/ca-dialog.base'
import { AuthContextStorageService } from '../../../../core/auth/auth-context-storage.service'
import { ErrorService } from '../../../../core/services/error.service'
import { UserContextStorageService } from '../../../../core/auth/user-context/user-context-storage.service'
import { PersonalDataControllerService, ProjectControllerService, ProjectCuzkLoginInfoDto } from '../../../../api/backend'
import { finalize } from 'rxjs/operators'
import _ from 'lodash'
import { Store } from '@ngrx/store'
import { MainViewActions } from '../../../../core/layout/state/action-types'

@Component({
    selector: 'ca-cuzk-login-dialog',
    templateUrl: './cuzk-login-dialog.html'
})
export class CuzkLoginDialogComponent extends CaDialogComponent<{
    hashes: string[];
    mode: string;
    parId: number;
    requestId: number;
    budId: number;
}, any> implements OnInit {

    actualDownloadType: any
    canEditCuzkSettings: boolean
    canWrite: boolean
    credentialsChanged = false
    cuzkCredentialsSaved = false
    downloadInProgress = false
    downloadTypeChanged = false
    errorMessage = ''
    loading = true
    loginData: any = {}
    title: string
    tryDownload = false
    wrongCredentials = false
    hashes: string[]
    mode: string
    parId: number
    requestId: number
    budId: number

    constructor(@Inject(Store) private store: Store,
                @Inject(AuthContextStorageService) private authContextStorageService: AuthContextStorageService,
                @Inject(ErrorService) private errorService: ErrorService,
                @Inject(PersonalDataControllerService) private personalDataControllerService: PersonalDataControllerService,
                @Inject(ProjectControllerService) private projectControllerService: ProjectControllerService,
                @Inject(UserContextStorageService) private userContextStorageService: UserContextStorageService,
                ) {
        super()
    }

    ngOnInit() {
        this.canEditCuzkSettings = this.authContextStorageService.hasPermission('edit_cuzk_settings')
        this.canWrite = this.authContextStorageService.hasPermission('write')
        this.title = this.getTitle()

        this.personalDataControllerService.checkCuzkAuthentication(
            this.authContextStorageService.getProjectKey(),
        ).pipe(
            finalize(() => {
                this.projectControllerService.getProjectCuzkLoginInfo(
                    this.authContextStorageService.getProjectKey(),
                    this.userContextStorageService.getProject().id,
                ).subscribe((project: ProjectCuzkLoginInfoDto) => {
                    this.loading = false

                    this.loginData = {
                        cuzkUsername: project.cuzkUsername,
                        cuzkDownloadPersonalData: project.cuzkDownloadPersonalData
                    }

                    this.cuzkCredentialsSaved = project.cuzkCredentialsSaved
                    this.actualDownloadType = project.cuzkDownloadPersonalData

                    if (this.cuzkCredentialsSaved) {
                        // generate fake password just to fill password input
                        // @ts-ignore
                        this.loginData.cuzkPassword = Math.random().toString(36).substring(5, 15)

                        if (this.hashes || this.requestId || this.mode === 'MANUAL_UPDATE_ALL' || this.mode === 'PARCEL_DETAIL') {
                            this.downloadPersonalData()
                        }
                    }
                }, error => this.errorService.onErrorResponseAlertUser(error))
            })
        ).subscribe(() => {},
        error => {
            this.wrongCredentials = true
            this.errorService.onErrorResponseAlertUser(error)
        })
    }

    downloadPersonalData(): void {
        if (this.validate()) {
            this.loading = true
            const credentials = this.resolveCredentials()

            if (this.requestId) {
                return this.repeatRequest({
                    credentials: credentials,
                    requestId: this.requestId
                })
            } else if (this.hashes) {
                return this.requestData({
                    credentials: credentials,
                    hashes: this.hashes,
                    requestSource: this.mode
                })
            } else if (this.mode === 'MANUAL_UPDATE_ALL') {
                this.requestData({
                    credentials: credentials,
                    downloadPersonalData: 'A',
                    requestSource: 'MANUAL_UPDATE'
                })
            } else if (this.mode === 'PARCEL_DETAIL') {
                this.requestData({
                    credentials: credentials,
                    parId: this.parId,
                    requestSource: this.mode
                })
            } else if (this.mode === 'BUILDING_DETAIL') {
                this.requestData({
                    credentials: credentials,
                    budId: this.budId,
                    requestSource: this.mode
                })
            }
        }
    }

    downloadFirstPersonalData(): void {
        this.loading = true

        this.requestData({
            credentials: this.resolveCredentials(),
            downloadPersonalData: this.actualDownloadType,
            requestSource: 'MANUAL_UPDATE'
        })
    }

    onChangeDownloadType(): void {
        this.actualDownloadType = this.loginData.cuzkDownloadPersonalData
        this.downloadTypeChanged = true
    }

    onChangePassword(): void {
        this.credentialsChanged = true
    }

    onChangeUsername(): void {
        this.loginData.cuzkPassword = null
        this.credentialsChanged = true
    }

    save(): void {
        if (this.validate()) {
            this.loading = true

            if (this.credentialsChanged) {
                this.personalDataControllerService.saveCuzkSettings(
                    this.authContextStorageService.getProjectKey(),
                    this.loginData
                ).subscribe(() => {
                    this.store.dispatch(MainViewActions.setCuzkPasswordValidityState({
                        cuzkPasswordValidityState: null
                    }))

                    // zadal jsem spravne heslo, vymazu pripadne skippedDateDueCuzkPasswordValidity
                    // protoze aktualizace se v noci spusti
                    this.store.dispatch(MainViewActions.setSkippedDateDueCuzkPasswordValidity({
                        skippedDateDueCuzkPasswordValidity: null
                    }))

                    this.personalDataControllerService.existDataToDownload(
                        this.authContextStorageService.getProjectKey(),
                    ).subscribe(exists => {
                        this.loading = false

                        if (exists) {
                            this.tryDownload = true
                        } else {
                            super.close()
                        }
                    })
                }, (error) => {
                    this.loading = false
                    this.wrongCredentials = true
                    this.errorService.onErrorResponseAlertUser(error)
                })
            } else if (this.downloadTypeChanged) {
                this.personalDataControllerService.saveDownloadType(
                    this.authContextStorageService.getProjectKey(),
                    this.loginData.cuzkDownloadPersonalData
                ).subscribe(() => {
                    this.loading = false
                    super.close()
                })
            } else {
                this.loading = false
                super.close()
            }
        }
    }

    // -------------------------------------------------------------------------

    private repeatRequest(repeatData): void {
        this.personalDataControllerService.repeatRequest(
            this.authContextStorageService.getProjectKey(),
            repeatData
        ).subscribe(() => {
            this.loading = false
            this.downloadInProgress = true
        }, () => this.setErrorState())
    }

    private requestData(requestData): void {
        this.personalDataControllerService.requestData(
            this.authContextStorageService.getProjectKey(),
            requestData
        ).subscribe(() => {
            this.loading = false
            this.downloadInProgress = true
        }, () => this.setErrorState())
    }

    private resolveCredentials(): any {
        if (this.cuzkCredentialsSaved) {
            return null // credentials are saved in DB so we don't need to send them
        } else {
            return {
                cuzkUsername: this.loginData.cuzkUsername,
                cuzkPassword: this.loginData.cuzkPassword,
                save: true
            }
        }
    }

    private setErrorState(): void {
        this.loading = false
        this.downloadInProgress = false
        this.errorMessage = 'Došlo k chybě při stahování osobních údajů.'
        this.wrongCredentials = true // force user fill new credentials
    }

    private validate(): boolean {
        this.errorMessage = ''

        if (!this.loginData.cuzkUsername) {
            this.errorMessage = 'Zadejte prosím uživatelské jméno.'
        } else if (!this.loginData.cuzkPassword) {
            this.errorMessage = 'Zadejte prosím heslo.'
        }

        return _.isEmpty(this.errorMessage)
    }

    private getTitle(): string {
        switch (this.mode) {
            case 'HEADER':
                return 'Přihlášení k webové službě pro stažení osobních údajů'
            default:
                return 'Stažení osobních údajů'
        }
    }
}